'use strict';

import $ from 'jquery';
import { lib } from '../../common/Library';

/**
 * ポートフォリオ－損益シミュレータ 設定額変更
 */
class SettingUpdate {
    // 設定額変更表示
    settingUpdateModal = () => {
        // オーバレイ表示
        this.settingUpdateModalOverlay();
        // モーダル表示
        $('#modal_setting_update').show();
    };

    // 設定額変更 オーバレイ表示
    settingUpdateModalOverlay = (animationSpeed = 'fast') => {
        $('body').append('<div id="modal_setting_update_overlay"></div>');
        $('#modal_setting_update_overlay').slideDown(animationSpeed);
        $('#modal_setting_update_overlay').on('click', () => {
            this.hideSettingUpdateModal();
        });
    };

    // 設定額変更 モーダル非表示
    hideSettingUpdateModal = () => {
        $('input[name="search_word"]').val('');

        $('#modal_setting_update').hide();
        this.hideSettingUpdateOverlay();
    };

    // 設定額変更 オーバレイ非表示
    hideSettingUpdateOverlay = (animationSpeed = 'fast') => {
        $('#modal_setting_update_overlay').slideUp(
            animationSpeed,
            function () {
                $('#modal_setting_update_overlay').remove();
            }
        );
    };

    // テーブル行生成
    makeSettingUpdateRow(data) {
        if (data) {
            $.map(data, function (value, key) {
                let num = Number(key) + 1;
                if (value.NAME_DISP !== null) {
                    $('#simulator').find('tbody').append('\
                    <tr>\
                        <td id="center">' + lib.escapeHtml(num) + '</td>\
                        <td id="left">\
                            <div class="stock_name">\
                                <span class="disp_setting_stock_name" title="' + lib.escapeHtml(value.NAME_DISP) + '">' + lib.escapeHtml(value.NAME_DISP) + '</span>\
                            </div>\
                            <div><span class="symbol">' + lib.escapeHtml(value.SYMBOL) + '&nbsp;</span><span class="market">\
                                ' + lib.escapeHtml(value.EXCHANGE_NAME_DISP) + '</span></div>\
                            <input type="hidden" name="su_simulator_id[]" value="' + lib.escapeHtml(value.SIMULATOR_ID) + '">\
                        </td>\
                        <td id="center">\
                            <input type="text" class="su_stock_number set_sim" name="su_stock_number[]"\
                                value="' + value.STOCK_NUMBER + '" required maxlength="9" pattern="^([0-9]{0,6}|0)(\\.[0-9]{1,2})?$">\
                            <span></span>\
                        </td>\
                        <td id="center">\
                            <input type="text" class="su_unit_price set_sim" name="su_unit_price[]"\
                                value="' + lib.escapeHtml(value.UNIT_PRICE) + '" required maxlength="7" pattern="^([0-9]{0,4}|0)(\\.[0-9]{1,2})?$">\
                        </td>\
                        <td id="center">\
                            <input type="text" class="su_setting_rate set_sim" name="su_setting_rate[]"\
                                value="' + lib.escapeHtml(value.SETTING_RATE) + '" required maxlength="6" pattern="^([0-9]{0,3}|0)(\\.[0-9]{1,2})?$">\
                        </td>\
                        <td id="center">\
                            <input type="text" class="su_acquisition_date set_sim" name="su_acquisition_date[]"\
                                value="' + lib.dateFormat(lib.escapeHtml(value.ACQUISITION_DATE), "yyyy/MM/dd") + '" required maxlength="10">\
                        </td>\
                    </tr>\
                ');
                }
            });
        }
    }

    // カーソル移動時のvalidate
    settingUpdateValide = () => {
        let result = true;
        // フォームからフォーカスを外したら発火（動的に生成する要素は'querySelectorAll'では取れないとのこと）
        // 設定株数
        const su_stock_number = document.getElementsByClassName('su_stock_number');
        for (let item of su_stock_number) {
            item.addEventListener('blur', (e) => {
                // パターンミスマッチの場合はバリデーションメッセージを書き換え
                if (item.validity.patternMismatch) {
                    item.setCustomValidity('半角数字で0～999999.99までで入力してください。');
                    // メッセージ出力
                    $(item)[0].reportValidity();
                }
                if (item.validity.valueMissing) {
                    item.setCustomValidity('半角数字で0～999999.99までで入力してください。');
                    // メッセージ出力
                    $(item)[0].reportValidity();
                }
            });
        }
        // 設定単価[ドル]
        const su_unit_price = document.getElementsByClassName('su_unit_price');
        for (let item of su_unit_price) {
            item.addEventListener('blur', (e) => {
                // パターンミスマッチの場合はバリデーションメッセージを書き換え
                if (item.validity.patternMismatch) {
                    item.setCustomValidity('半角数字で0～9999.99までで入力してください。');
                    // メッセージ出力
                    $(item)[0].reportValidity();
                }
                if (item.validity.valueMissing) {
                    item.setCustomValidity('半角数字で0～9999.99までで入力してください。');
                    // メッセージ出力
                    $(item)[0].reportValidity();
                }
            });
        }
        // 設定レート[円]
        const su_setting_rate = document.getElementsByClassName('su_setting_rate');
        for (let item of su_setting_rate) {
            item.addEventListener('blur', (e) => {
                // パターンミスマッチの場合はバリデーションメッセージを書き換え
                if (item.validity.patternMismatch) {
                    item.setCustomValidity('半角数字で0～999.99までで入力してください。');
                    // メッセージ出力
                    $(item)[0].reportValidity();
                }
                if (item.validity.valueMissing) {
                    item.setCustomValidity('半角数字で0～999.99までで入力してください。');
                    // メッセージ出力
                    $(item)[0].reportValidity();
                }
            });
        }
        // 取得日
        const su_acquisition_date = document.getElementsByClassName('su_acquisition_date');
        for (let item of su_acquisition_date) {
            item.addEventListener('blur', (e) => {
                if (!lib.checkDate(item.value)) {
                    item.setCustomValidity('"YYYY/MM/DD"で入力してください。');
                    // メッセージ出力
                    $(item)[0].reportValidity();
                }
                if (item.validity.valueMissing) {
                    item.setCustomValidity('"YYYY/MM/DD"で入力してください。');
                    // メッセージ出力
                    $(item)[0].reportValidity();
                }
            });
        }
    }

    // ボタン押下時の制御用validate
    settingUpdateButtonClickValide = () => {
        let result = true;
        // フォームからフォーカスを外したら発火（動的に生成する要素は'querySelectorAll'では取れないとのこと）
        // 設定株数
        const su_stock_number = document.getElementsByClassName('su_stock_number');
        for (let item of su_stock_number) {
            if (item.validity.patternMismatch) {
                item.setCustomValidity('半角数字で0～999999.99までで入力してください。');
                // メッセージ出力
                $(item)[0].reportValidity();
                result = false;
                break;
            }
            if (item.validity.valueMissing) {
                item.setCustomValidity('半角数字で0～999999.99までで入力してください。');
                // メッセージ出力
                $(item)[0].reportValidity();
                result = false;
                break;
            }
        }
        // 設定単価[ドル]
        const su_unit_price = document.getElementsByClassName('su_unit_price');
        for (let item of su_unit_price) {
            if (item.validity.patternMismatch) {
                item.setCustomValidity('半角数字で0～9999.99までで入力してください。');
                // メッセージ出力
                $(item)[0].reportValidity();
                result = false;
                break;
            }
            if (item.validity.valueMissing) {
                item.setCustomValidity('半角数字で0～9999.99までで入力してください。');
                // メッセージ出力
                $(item)[0].reportValidity();
                result = false;
                break;
            }
        }
        // 設定レート[円]
        const su_setting_rate = document.getElementsByClassName('su_setting_rate');
        for (let item of su_setting_rate) {
            if (item.validity.patternMismatch) {
                item.setCustomValidity('半角数字で0～999.99までで入力してください。');
                // メッセージ出力
                $(item)[0].reportValidity();
                result = false;
                break;
            }
            if (item.validity.valueMissing) {
                item.setCustomValidity('半角数字で0～999.99までで入力してください。');
                // メッセージ出力
                $(item)[0].reportValidity();
                result = false;
                break;
            }
        }
        // 取得日
        const su_acquisition_date = document.getElementsByClassName('su_acquisition_date');
        for (let item of su_acquisition_date) {
            if (!lib.checkDate(item.value)) {
                item.setCustomValidity('"YYYY/MM/DD"で入力してください。');
                // メッセージ出力
                $(item)[0].reportValidity();
                result = false;
                break;
            }
            if (item.validity.valueMissing) {
                item.setCustomValidity('"YYYY/MM/DD"で入力してください。');
                // メッセージ出力
                $(item)[0].reportValidity();
                result = false;
                break;
            }
        }
        return result;
    }
}
export const settingUpdate = new SettingUpdate();